import { connect } from 'react-redux';

import patientRome from '../next/office/pages/index';

export default connect(null, null)(patientRome);
